import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { RO_COURSE_ADMIN_PREVIEW } from '../../data/rangeOfficerCourse/types';
import { ProtectedRoute } from './ProtectedRoute';

interface RangeOfficerCourseRouteProps {
  children: React.ReactNode;
}

/**
 * Logged-in route for the online Range Officer course.
 *
 * While `RO_COURSE_ADMIN_PREVIEW` is false this is the same as `ProtectedRoute`.
 * While it is true, a signed-in member who is not an admin is sent to the
 * dashboard instead of an access-denied screen.
 */
const AdminPreviewGate: React.FC<RangeOfficerCourseRouteProps> = ({ children }) => {
  const { isAdmin } = useAuth();
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export const RangeOfficerCourseRoute: React.FC<RangeOfficerCourseRouteProps> = ({ children }) => {
  if (!RO_COURSE_ADMIN_PREVIEW) {
    return <ProtectedRoute>{children}</ProtectedRoute>;
  }

  return (
    <ProtectedRoute>
      <AdminPreviewGate>{children}</AdminPreviewGate>
    </ProtectedRoute>
  );
};
